import { lazy } from 'react';
import { UtensilsCrossed, CookingPot, BookOpen } from 'lucide-react';
import type { MealEntry, Recipe } from '@app/shared';
import type { SearchResult, WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';
import { friendlyDate } from '../../platform/time.ts';

export const mealsModule: WebModule = {
  id: 'meals',
  label: 'Meals',
  icon: UtensilsCrossed,
  path: '/meals',
  nav: { group: 'main', order: 40 },
  routes: [
    { path: 'meals', lazy: async () => ({ Component: (await import('./MealsScreen.tsx')).MealsScreen }) },
    { path: 'meals/recipes', lazy: async () => ({ Component: (await import('./RecipesScreen.tsx')).RecipesScreen }) },
    { path: 'meals/recipes/:recipeId', lazy: async () => ({ Component: (await import('./RecipesScreen.tsx')).RecipeScreen }) },
  ],
  home: [{ id: 'meals', title: 'Meals today', order: 50, component: lazy(() => import('./home.tsx').then((m) => ({ default: m.MealsToday }))) }],
  quickActions: [{ id: 'meal', label: 'Meal', icon: CookingPot, to: '/meals?add=1', adultOnly: true }],
  async search(q, ctx) {
    const out: SearchResult[] = [];
    for (const r of await familyRecords<Recipe>('recipes', ctx.familyId)) {
      const score = scoreText(q, [r.name, r.ingredients.join(' '), r.tags.join(' '), r.instructions]);
      if (score) out.push({ key: `recipes:${r.id}`, title: r.name, subtitle: 'Recipe', to: `/meals/recipes/${r.id}`, group: 'Meals', icon: BookOpen, score });
    }
    for (const m of await familyRecords<MealEntry>('meal_entries', ctx.familyId)) {
      const score = scoreText(q, [m.title, m.notes]);
      if (score)
        out.push({
          key: `meal_entries:${m.id}`,
          title: m.title,
          subtitle: `${friendlyDate(m.date)} · ${m.slot}`,
          to: `/meals?week=${m.date}`,
          group: 'Meals',
          icon: UtensilsCrossed,
          score,
        });
    }
    return out;
  },
};
